import {
  API_ENDPOINTS,
  CONSTANT,
  ENDPOINT_METHODS,
  HEADER_PARAMS,
} from '../constants/constants';
import { properties } from '../constants/properties';

export const addRegistrationAPI = async (payload) => {
  //URLs
  let REGISTRATION_URL = API_ENDPOINTS.ADD_CONFERENCE_REGISTRATION_API;

  //RegistrationAPI Header
  const registrationAPIHeaders = new Headers();
  registrationAPIHeaders.append(
    HEADER_PARAMS.CONTENT_TYPE,
    HEADER_PARAMS.APPLICATION_TYPE
  );

  //Registration request options
  const registrationRequestOptions = {
    method: ENDPOINT_METHODS.METHOD_POST,
    headers: registrationAPIHeaders,
    body: JSON.stringify(payload),
  };

  return await kuAPI(REGISTRATION_URL, registrationRequestOptions);
};

export const getConferenceDetailsAPI = async (payload) => {
  let URL = API_ENDPOINTS.GET_CONFERENCE_DETAILS;
  URL = URL.replace(CONSTANT.CONFERENCE_ID, payload?.id);

  const myHeaders = new Headers();
  myHeaders.append(HEADER_PARAMS.CONTENT_TYPE, HEADER_PARAMS.APPLICATION_TYPE);

  const requestOptions = {
    method: ENDPOINT_METHODS.METHOD_GET,
    headers: myHeaders,
  };

  return await kuAPI(URL, requestOptions);
};

export const getConferenceSubscriptionAPI = async (payload) => {
  let URL = API_ENDPOINTS.GET_CONFERENCE_SUBSCRIPTION;
  URL = URL.replace(CONSTANT.CONFERENCE_ID, payload?.id);

  const myHeaders = new Headers();
  myHeaders.append(HEADER_PARAMS.CONTENT_TYPE, HEADER_PARAMS.APPLICATION_TYPE);

  const requestOptions = {
    method: ENDPOINT_METHODS.METHOD_GET,
    headers: myHeaders,
  };

  return await kuAPI(URL, requestOptions);
};

export const getCountryListAPI = async () => {
  let URL = API_ENDPOINTS.GET_COUNTRY_LIST;

  const myHeaders = new Headers();
  myHeaders.append(HEADER_PARAMS.CONTENT_TYPE, HEADER_PARAMS.APPLICATION_TYPE);

  const requestOptions = {
    method: ENDPOINT_METHODS.METHOD_GET,
    headers: myHeaders,
  };

  return await kuAPI(URL, requestOptions);
};

export const getKUConfigurationAPI = async () =>{
  let URL = API_ENDPOINTS.GET_KU_CONFIGURATION;

  const myHeaders = new Headers();
  myHeaders.append(HEADER_PARAMS.CONTENT_TYPE, HEADER_PARAMS.APPLICATION_TYPE);

  const requestOptions = {
    method: ENDPOINT_METHODS.METHOD_GET,
    headers: myHeaders,
  };

  return await kuAPI(URL, requestOptions);
};

export const getKUPaperFeesmappingAPI = async (payload) =>{
  let URL = API_ENDPOINTS.GET_PAPER_FEES_MAPPING;
  URL = URL.replace(CONSTANT.CONFERENCE_ID, payload?.id);
  const myHeaders = new Headers();
  myHeaders.append(HEADER_PARAMS.CONTENT_TYPE, HEADER_PARAMS.APPLICATION_TYPE);

  const requestOptions = {
    method: ENDPOINT_METHODS.METHOD_GET,
    headers: myHeaders,
  };

  return await kuAPI(URL, requestOptions);
};

export const getConferenceConfigurationAPI = async (payload) =>{
  let URL = API_ENDPOINTS.GET_CONFERENCE_CONFIGURATION;
  URL = URL.replace(CONSTANT.CONFERENCE_ID, payload?.id);
  const myHeaders = new Headers();
  myHeaders.append(HEADER_PARAMS.CONTENT_TYPE, HEADER_PARAMS.APPLICATION_TYPE);

  const requestOptions = {
    method: ENDPOINT_METHODS.METHOD_GET,
    headers: myHeaders,
  };

  return await kuAPI(URL, requestOptions);
};

export const getRegistrationTypeListAPI = async () => {
  let URL = API_ENDPOINTS.GET_REGISTRATION_TYPE_LIST;
  const myHeaders = new Headers();
  myHeaders.append(HEADER_PARAMS.CONTENT_TYPE, HEADER_PARAMS.APPLICATION_TYPE);

  const requestOptions = {
    method: ENDPOINT_METHODS.METHOD_GET,
    headers: myHeaders,
  };

  return await kuAPI(URL, requestOptions);
};

export const getConferenceDocumentsAPI = async (payload) => {
  const myHeaders = new Headers();
  myHeaders.append(HEADER_PARAMS.CONTENT_TYPE, HEADER_PARAMS.APPLICATION_TYPE);

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
  };

  let URL = API_ENDPOINTS.GET_CONFERENCE_DOCUMENTS;
  URL = URL.replace(CONSTANT.CONFERENCE_ID, payload?.id);
  return await kuAPI(URL, requestOptions);
};

const kuAPI = async (url, requestOptions) => {
  function customQueryEncoder(params) {
    const query = Object.keys(params)
      .map((key) => {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(params[key]);
        return `${encodedKey}=${encodedValue}`;
      })
      .join('&');
    return query;
  }

  // Example usage of the custom encoder helper function
  const params = {
    doAsUserId: properties.doAsUserId,
  };

  // Encode the parameters using the custom encoder helper function
  const encodedParams = customQueryEncoder(params);

  url = `${url}&${encodedParams}`;

  return fetch(url, requestOptions)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }else if (response?.status === 409) {
        return response;
      } else {
        return undefined;
      }
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
};
